import { ElxCard, IElxCardProps } from '@elixir/components';
import React from 'react';

export const EHCard = (props: IElxCardProps): JSX.Element => {
  return <ElxCard {...props} />;
};
